import React from 'react';
import styled from 'styled-components';
import { start, stop } from '@/lib/responsive';
import { Spin } from 'antd';

const PDFWrapper = styled.main`
  width: 100vw;
  height: 100vh;
`;

const PDFEmbedded: React.FC<{ url: string }> = ({ url }) => {
  const src = `https://docs.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(url)}`;
  React.useEffect(() => {
    stop();
    return start;
  }, []);
  const [loading, setLoading] = React.useState(true);
  return (
    <Spin spinning={loading}>
      <PDFWrapper>
        <iframe onLoad={() => setLoading(false)} src={src} style={{ width: '100%', height: '100%' }} />
      </PDFWrapper>
    </Spin>
  );
};

export default PDFEmbedded;
